
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FaviconService {
  private setIcon(href: string) {
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel*='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.href = href;
  }

  public updateFavicon(path: string) {
    // mapeamento baseado na rota
    if (path.startsWith('/i')) {
      this.setIcon('/assets/img/favicon-angel.svg');
    } else if (path.startsWith('/checkout/angel')) {
      this.setIcon('/assets/img/favicon-angel.svg');
    } else if (path.startsWith('/checkout/self')) {
      this.setIcon('/assets/img/favicon-2.png');
    } else {
      this.setIcon('/assets/img/favicon.png'); // padrão
    }
  }
}
